import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative max-w-[1280px] mx-auto px-4 md:px-6 py-20 flex flex-col items-center text-center overflow-hidden">
      <span className="absolute text-9xl md:text-[12rem] font-heading font-black text-background-200 select-none pointer-events-none">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <span className="w-20 h-20 rounded-full bg-background-100 flex items-center justify-center mb-5">
          <i className="ri-roadster-line text-4xl text-accent-500" />
        </span>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
          页面未找到
        </h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono break-all">
          {location.pathname}
        </p>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md">
          你访问的页面不存在或已被移除。可以返回首页，或通过顶部导航继续浏览汽车新闻、车型评测与行业动态。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="h-10 px-5 rounded-md bg-primary-600 text-background-50 text-sm flex items-center gap-1.5 hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/news"
            className="h-10 px-5 rounded-md border border-background-300 text-foreground-800 text-sm flex items-center gap-1.5 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览汽车新闻
          </Link>
        </div>
      </div>
    </div>
  );
}